/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { GetUserContactsCount200Response } from '../model/models';
import { InquiryContactResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface InquiryContactServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get user to inquiry contacts count
     * 
     * @param userId 
     */
    getUserInquiryContactsCount(userId?: number, extraHttpRequestParams?: any): Observable<GetUserContactsCount200Response>;

    /**
     * Inquiry contact detail
     * 
     * @param callId 
     */
    inquiryContactDetail(callId: number, extraHttpRequestParams?: any): Observable<InquiryContactResource>;

    /**
     * Inquiry contact list
     * 
     */
    inquiryContactList(extraHttpRequestParams?: any): Observable<Array<InquiryContactResource>>;

}
